import { render, staticRenderFns } from "./TnssBlock.vue?vue&type=template&id=e2d1d396&lang=pug&"
import script from "./TnssBlock.vue?vue&type=script&lang=js&"
export * from "./TnssBlock.vue?vue&type=script&lang=js&"
import style0 from "./TnssBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports